import {
  PRODUCT_DASHBOARD_SEARCH_RESULTS_LOADED,
  PRODUCT_DASHBOARD_SEARCH_RESULTS_CLEAR,
  PRODUCT_DASHBOARD_SEARCH_RESULTS_META_LOADED,
  PRODUCT_DASHBOARD_SEARCH_RESULTS_META_CLEAR,
} from '../../../actions/actionTypes';

const initialState = {
  productSearchResultsData: null,
  productSearchResultsMeta: null,
};

const productDashboard = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_DASHBOARD_SEARCH_RESULTS_LOADED:
      return { ...state, productSearchResultsData: action.payload.result };

    case PRODUCT_DASHBOARD_SEARCH_RESULTS_CLEAR:
      return { ...state, productSearchResultsData: null };

    case PRODUCT_DASHBOARD_SEARCH_RESULTS_META_LOADED:
      return { ...state, productSearchResultsMeta: action.payload.result };

    case PRODUCT_DASHBOARD_SEARCH_RESULTS_META_CLEAR:
      return { ...state, productSearchResultsMeta: null };

    default:
      return state;
  }
};

export default productDashboard;
